import React, { useState } from 'react';
import useProductNotification from '../Hooks/useProductNotification';
import { toast, ToastContainer } from "react-toastify";

const ProductNotification = ({dt, close}) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { ProductNotification, isLoading, success } = useProductNotification();

  const handleChange = (e) => {
    setEmail(e.target.value);
    setError(''); // Clear error on input change
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation
    if (!emailRegex.test(email)) {
      toast.error('Please enter a valid email address.');
      return;
    }

    setIsSubmitting(true);
    try {
    
     const res = await ProductNotification(email,dt.id); // Call the hook's function to handle the API request
      toast.success('Thank you for subscribing!');
      setEmail(''); // Clear the input field after successful submission
      close();
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-10 bg-white p-6 rounded-lg shadow-md flex flex-col md:flex-row gap-6">
      
  
      {/* Form Section */}
      <div className="w-full md:w-1/2 bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-sm font-semibold text-gray-800 mb-4">
          Provide your email address, we will notify you as the stock updates
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={handleChange}
              className={`w-full px-4 py-2 border ${
                error ? 'border-red-500' : 'border-gray-300'
              } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500`}
              placeholder="Enter your email"
              required
              disabled={isSubmitting}
            />
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
          </div>
          <button
            type="submit"
            className={`w-full py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600 transition ${
              isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Subscribe'}
          </button>
        </form>
      </div>

      {/* Image Section */}
      <div className="w-full md:w-1/2">
        <img
          src={dt.image}
          alt="Product"
          className="w-full h-full object-cover rounded-lg shadow-md"
        />
      </div>
    </div>
  );
  
};

export default ProductNotification;
